




























































































































import { Component, Watch, Vue, Prop } from 'vue-property-decorator'
import * as Types from '../../mini'
import { env } from '@ivy/fts/envInfo/envInfo'

@Component({
  inheritAttrs: false,
})
export default class PictureBook extends Vue {
  @Prop({ default: () => {} }) data: Types.PictureBook
  @Prop({ default: () => {} }) compData: any
  @Prop() uploadEvent: any
  @Prop({ default: () => {} }) config: any
  vip_config: any = null
  list: any[] = []

  get boxStyle() {
    return `background: ${this.data.bgColor || '#F5F5F5'};
            padding: 0 ${this.data.compMargin}px;
            --contentMargin: ${(this.data.spacing || 0) / 2}px;
            --conentRadio2: ${(this.data.spacing / 3) * 2}px;
            --conentRadio3: ${this.data.spacing / 3}px`
  }

  get radiusStyle() {
    return `border-radius: ${this.data.radius}px`
  }

  get coverFill() {
    return `object-fit: ${this.data.filling}; ${this.radiusStyle}`
  }

  get vipStyle() {
    return marker => {
      if (!marker) {
        return {}
      } else {
        return {
          backgroundColor: marker.back_color,
          color: marker.font_color,
        }
      }
    }
  }
  get noticeStyle() {
    return `background: ${this.vip_config.back_color};
           color:${this.vip_config.font_color};
           border-radius: 0px ${this.data.radius}px 0px 10px`
  }

  @Watch('data.list', { immediate: true, deep: true })
  async getEbooksList() {
    if (this.config && this.config.vip_config) {
      this.vip_config = this.config.vip_config
    }
    let ids = this.data.list.map(item => item.id)
    if (ids && ids.length) {
      let { data } = await this.$axios.get(
        '/api/audios/resource/pictureBook/getByIds',
        {
          params: {
            ids: ids,
            offset: 0,
            limit: 100,
          },
        }
      )
      let map = new Map()
      let rows = data || []
      rows.forEach(element => {
        map.set(element.id, element)
      })
      this.list = []
      this.data.list.map(r => {
        if (map.get(r.id)) {
          this.list.push(map.get(r.id))
        }
      })
    } else {
      this.list = []
    }
  }

  formatPlayCount(data) {
    let count = data.playcount
    if (+count >= 100000000) return `${(+count / 100000000).toFixed(1)}亿`
    if (+count >= 10000) return `${(+count / 10000).toFixed(1)}万`
    return count || 0
  }
  async goPictureBook(value) {
    // 微页面组件内容点击埋点
    await this.uploadEvent.sendRecord(
      'Click_MicroPages_Component',
      '',
      {
        PageName: document.title,
        ComponentName: this.data.title,
        ContentName: value.title,
        JumpType: '绘本详情',
        JumpContentName: value.title,
        JumpContentID: value.id,
        isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
      },
      [
        ['p1', 'PageName'],
        ['p2', 'ComponentName_ContentName'],
        ['p3', 'isTabPage'],
        ['p4', 'JumpType_JumpContentID_JumpContentName'],
      ]
    )

    if (env.type === 'ivydad' || env.type === 'wx') {
      env.commonJump('ivydadReadtool://detail/pictureBook?id=' + value.id)
    } else {
      this.$Toast('请在微信或者app端打开~')
    }

    // this.$router.push({
    //   path: 'book-detail',
    //   query: {
    //     id: value.id,
    //   },
    // })
  }
}
